import { PLAYER_SEARCH_MIN_CHARS } from '../hooks/usePlayerSearch'

/**
 * The empty/no-results card states for the Roster Add Player modal.
 * - `idle`     — query too short; prompt the user to start typing.
 * - `searching`— a query is in flight.
 * - `empty`    — search settled with zero results.
 * - `hidden`   — results exist; the antd dropdown shows them, card is hidden.
 */
export type PlayerSearchCardState = 'idle' | 'searching' | 'empty' | 'hidden'

interface Params {
  query: string
  isSearching: boolean
  resultCount: number
}

export const getPlayerSearchCardState = ({
  query,
  isSearching,
  resultCount,
}: Params): PlayerSearchCardState => {
  if (query.trim().length < PLAYER_SEARCH_MIN_CHARS) {
    return 'idle'
  }
  if (isSearching) {
    return 'searching'
  }
  return resultCount === 0 ? 'empty' : 'hidden'
}
